$(document).ready(function(){
  $('img[src="//herjuicebar.com/cdn/shop/files/HJB-Logo-brown.png?v=1687285880"]').attr('alt', 'Her Juice Bar logo ');
$('img[src="//herjuicebar.com/cdn/shop/files/ESI_stock-40_1_03d37669-ec4d-48ae-829c-becdacfb5b6f2.jpg?v=1689019043&width=480"]').attr('alt', 'Founder of Her Juice Bar, Abigail, sitting on a couch and posing for a picture');


$('img[src="//herjuicebar.com/cdn/shop/files/hjb-logo.png?v=1687285822"]').attr('alt', 'Her Juice Bar logo');

$('img[src="//herjuicebar.com/cdn/shop/files/TurmericTonic_copy_3a7af1ab-036b-4306-a2ef-2b00a87678e0.jpg?v=1694635924&width=480"]').attr('alt', 'Turmeric Tonic');

$('img[src="//herjuicebar.com/cdn/shop/files/bundle_save.jpg?v=1694722776&width=480"]').attr('alt', 'Her juice bar products');
$("h2:empty").append("<span style='display:none'>.</span>");
  $("h4:empty").append("<span style='display:none'>.</span>");
  $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/WSXXFw/images/031dc05b-5ce8-4392-afbd-fad7fb32914a.jpeg"]').attr('alt', 'Her Juice Bar for daily harmony');
$("button#sca-fg-today-offer-widget").append("<span style='display:none'>.</span>");
  $('select[name="sort_by"]').removeAttr('aria-describedby');
$("button.thumbnail.element--border-radius").attr("aria-label","Prduct thumbnail");
  $('img[src="//herjuicebar.com/cdn/shop/files/Soft.png?v=1691175393"]').attr('alt', 'Softness icon');

$('img[src="//herjuicebar.com/cdn/shop/files/cleanicons.png?v=1694735468"]').attr('alt', 'Clean formula icon');

$('img[src="//herjuicebar.com/cdn/shop/files/skin.png?v=1691174839"]').attr('alt', 'Skin care icon');

$('img[src="//herjuicebar.com/cdn/shop/files/clean-ingredients.webp?v=1691156208"]').attr('alt', 'Clean ingredients icon');

$('img[src="//herjuicebar.com/cdn/shop/files/HoneyDewDrop_756ff827-a167-4824-9e9a-0812a7692e34.png?v=1701910240"]').attr('alt', 'Her Juice Bar Honey Dew Drop');
$('img[src="//herjuicebar.com/cdn/shop/files/water.webp?v=1691156188"]').attr('alt', 'Hydration water icon');

$('img[src="//herjuicebar.com/cdn/shop/files/gyno_03422ce1-68a9-4fb6-a20e-91df33b68a6e.png?v=1687285984"]').attr('alt', 'Gynae doctor icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Wet_Martini_f2a82765-5786-446a-ae09-05c200cde2c9.png?v=1692921974"]').attr('alt', 'Her Juice Bar Wet Martini');

$('img[src="//herjuicebar.com/cdn/shop/files/calendar.webp?v=1691156195"]').attr('alt', 'Calendar icon');
$('img[src="//herjuicebar.com/cdn/shop/files/derma.png?v=1691174828"]').attr('alt', 'Dermatologist approved icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Body_Shot_-_Large_1a17d684-a06e-47a3-889e-e0bd7f576e55.png?v=1694720091"]').attr('alt', 'Her Juice Bar Body Shot');

$('button.ctm_prev').attr('aria-label', 'Compare');
$('img[src="//herjuicebar.com/cdn/shop/files/The_Body_Shot.png?v=1692921780"]').attr('alt', 'Her Juice Bar Body Shot');

$('img[src="//herjuicebar.com/cdn/shop/files/smell.png?v=1691173759"]').attr('alt', 'Fragrance icon');

$('img[src="//herjuicebar.com/cdn/shop/files/ph_balancing.png?v=1691174947"]').attr('alt', 'pH balancing icon');

$('img[src="//herjuicebar.com/cdn/shop/files/bacteria.png?v=1691173794"]').attr('alt', 'Bacteria protection icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Untitled_design.png?v=1721056019"]').attr('alt', 'Hormone Balance Blend Capsules');

$('img[src="//herjuicebar.com/cdn/shop/files/TeaTreeDaiquiri-shadow.png?v=1692921574"]').attr('alt', 'Her Juice Bar Tea Tree Daiquiri');

$('img[src="//herjuicebar.com/cdn/shop/files/The_Mocktail_4f5fba76-8962-4884-b3d4-41b7984e27af.png?v=1692921501"]').attr('alt', 'Her Juice Bar The Mocktail');

$('img[src="//herjuicebar.com/cdn/shop/files/Lavender-Sangria.png?v=1692921682"]').attr('alt', 'Her Juice Bar Lavender Sangria');

$('img[src="//herjuicebar.com/cdn/shop/files/Bellini_Bliss.png?v=1693448551"]').attr('alt', 'Her Juice Bar Bellini Bliss');

$('img[src="//herjuicebar.com/cdn/shop/files/female_2x2_25feb67c-976d-4906-bcf3-f0c3a481ebef.png?v=1689019138"]').attr('alt', 'Female health icon');

$('img[src="//herjuicebar.com/cdn/shop/files/teatreeicons.png?v=1694735634"]').attr('alt', 'Tea Tree icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Lychee_Bloom.png?v=1693448727"]').attr('alt', 'Her Juice Bar Lychee Bloom');

$('img[src="//herjuicebar.com/cdn/shop/files/clean2icons.png?v=1694735668"]').attr('alt', 'Clean skincare icon');

$('img[src="//herjuicebar.com/cdn/shop/files/brightenicons.png?v=1694735655"]').attr('alt', 'Sunshine brighten icon');

$('img[src="//herjuicebar.com/cdn/shop/files/strawberryicons.png?v=1694735482"]').attr('alt', 'Strawberry icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Peachy_Puree.png?v=1701884865"]').attr('alt', 'Her Juice Bar Peachy Puree');

$('img[src="//herjuicebar.com/cdn/shop/files/Untitled_design-14.png?v=1708627239"]').attr('alt', 'Her Juice Bar Date Night Tincture');

$('img[src="//herjuicebar.com/cdn/shop/files/Pink_Oasis.png?v=1694738772"]').attr('alt', 'Her Juice Bar Pink Oasis');

$('img[src="//herjuicebar.com/cdn/shop/files/Sex_on_the_Peach.png?v=1701913999"]').attr('alt', 'Her Juice Bar Sex on the Peach');

$('img[src="//herjuicebar.com/cdn/shop/files/Long_Island_Tea-Shadow.png?v=1701912234"]').attr('alt', 'Her Juice Bar Long Island Tea');

$('img[src="//herjuicebar.com/cdn/shop/files/everyone_2x_47e48398-eefa-41e4-9576-bb6112bd06f32.png?v=1687286035"]').attr('alt', 'Heart icon');

$('img[src="//herjuicebar.com/cdn/shop/files/Untitled_design-18.png?v=1724943537"]').attr('alt', 'Her Spritzier Wipes');
$('a.rc_popup__learn_more').attr('aria-label', 'Learn more about the subscription');
$('img[src="//herjuicebar.com/cdn/shop/files/Everything-Group.jpg?v=1711646478&width=480"]').attr('alt', 'Her Juice Bar Products Group');

$('img[src="//herjuicebar.com/cdn/shop/files/LongIslandTea_484ce002-39ed-4acc-8eef-55ebc61b7b54.jpg?v=1701912595&width=480"]').attr('alt', 'Her Juice Bar Long Island Tea Front Side');

$('img[src="//herjuicebar.com/cdn/shop/files/SexonthePeach_d675c53c-60b3-4728-aa4c-2404c1cd5009.jpg?v=1701913309&width=480"]').attr('alt', 'Her Juice Bar Sex on the Peach Front Side');

$('img[src="//herjuicebar.com/cdn/shop/files/PinkOasis.jpg?v=1694712066&width=480"]').attr('alt', 'Her Juice Bar Pink Oasis Front Side');

$('img[src="//herjuicebar.com/cdn/shop/files/Bundle_-_No_Shadow.jpg?v=1693445022&width=480"]').attr('alt', 'Her Juice Bar Body Shot and Bellini Bliss Front Side ');

$('img[src="//herjuicebar.com/cdn/shop/files/Lavender-Motion.jpg?v=1694478445&width=480"]').attr('alt', 'Her Juice Bar Lavender Motion Front Side');

$('img[src="//herjuicebar.com/cdn/shop/files/TheMocktail_dcd3e480-7ebb-4012-a13f-928a54a9d12e.jpg?v=1694634872&width=480"]').attr('alt', 'Her Juice Bar The Mocktail Front Side');

$('img[src="//herjuicebar.com/cdn/shop/files/Tea20Tree20Foam.jpg?v=1693439262&width=480"]').attr('alt', 'Her Juice Bar Tea Tree Daiquiri bottle wrapped in foam');
$("h3:empty").append("<span style='display:none'>.</span>");
  $("h1:empty").append("<span style='display:none'>.</span>");
    $("h4>strong:empty").append("<span style='display:none'>.</span>");
  $('a[data-start="4139"][data-end="4168"]').attr('aria-label', 'Shop the Body Shot');
$('img[src="//herjuicebar.com/cdn/shop/files/Homepage-Group2_copy.jpg?v=1694635170&width=480"]').attr('alt', 'Her Juice Bar products on shelf');

$('img[src="//herjuicebar.com/cdn/shop/files/Bundle2.jpg?v=1694355431&width=480"]').attr('alt', 'Her Juice Bar products on shelf');

$('img[src="//herjuicebar.com/cdn/shop/files/0P0A9620-Edit_copy.jpg?v=1694201123&width=480"]').attr('alt', 'Her Juice Bar products on shelf along with water bottle and glass');

$('img[src="//herjuicebar.com/cdn/shop/files/thebodyshot-crop.jpg?v=1693166330&width=480"]').attr('alt', 'The Body Shot travel front side');

$('img[src="//herjuicebar.com/cdn/shop/files/ESI_stock-85_c5e43ccd-c522-4ebe-b151-c0f9d8fac1f72.jpg?v=1687286137&width=480"]').attr('alt', 'Her Juice Bar founder sitting on sofa and posing for a picture');

  $('img[src="//herjuicebar.com/cdn/shop/files/herjuice-white.png?v=1687285738&width=200"]').attr('alt', 'Her Juice Bar Logo in White');

  let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

$('a.rc_popup__learn_more').attr('aria-label', 'Learn more about the subscription');
  $('a[href="http://rechargepayments.com/subscribe-with-recharge"]').attr('aria-label', 'Learn more about the subscription');

     $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/WSXXFw/images/031dc05b-5ce8-4392-afbd-fad7fb32914a.jpeg"]').attr('alt', 'Her Juice Bar for daily harmony');
    if ( $('#goog-gt-votingInputSrcLang').length) {
      
$('div.yotpo-email-container input').removeAttr('aria-describedby');
$('div.yotpo-email-container input').removeAttr('aria-describedby');
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

console.log("ready");
});
